import { render, staticRenderFns } from "./dictionaryItem.vue?vue&type=template&id=d7faca74&scoped=true"
import script from "./dictionaryItem.vue?vue&type=script&lang=js"
export * from "./dictionaryItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7faca74",
  null
  
)

export default component.exports